import type * as React from "react";

import {
	RadioGroup as CrowRadioGroup,
	RadioGroupItem as CrowRadioGroupItem,
} from "@crow/ui/radio";

/**
 * The design system's radio group (`design-system/ui`): a group of choices, one picked; arrows
 * move between them, Space picks.
 */
function RadioGroup(props: React.ComponentProps<typeof CrowRadioGroup>) {
	return <CrowRadioGroup data-slot="radio-group" {...props} />;
}

/**
 * One choice of a `RadioGroup`, as a whole row: its content (a title, a line under it) beside the
 * round indicator, or alone when `indicator` is false.
 */
function RadioGroupItem(props: React.ComponentProps<typeof CrowRadioGroupItem>) {
	return <CrowRadioGroupItem data-slot="radio-group-item" {...props} />;
}

export { RadioGroup, RadioGroupItem };
